import { PropType, VueConstructor, defineComponent, h } from 'vue'
import { INotificationItem } from '../NotificationItemBase'
import { VCard, VCardText } from 'vuetify/lib'

interface Metadata {
	Message: string
	Author: string
}

import './NotificationProposalObservation.scss'
import { CaptureEvent, Events } from '@/services/AmplitudeService'

export const NotificationProposalObservation = defineComponent({
	name: 'NotificationProposalObservation',
	props: {
		notification: { type: Object as PropType<INotificationItem>, required: true }
	},

	data: () => ({
		expanded: false
	}),

	methods: {
		toggleText(e: Event) {
			e.stopPropagation()
			this.expanded = !this.expanded
			this.$emit('notification:clicked', this.notification.id)
			CaptureEvent(Events.NotificationClickedProposalObservation)
		}
	},

	computed: {
		metadata(): Metadata {
			return JSON.parse(this.notification.metadata) as Metadata
		},

		observationText(): string {
			return this.metadata.Message
		}
	},

	render() {
		return (
			<VCard outlined elevation={0}>
				<VCardText class="notification-proposal-observation">
					<div class="message-author">{this.metadata.Author}</div>
					{h('div', {
						style: 'white-space: pre-wrap;',
						class: ['notification-proposal-observation-message text-overflow', this.expanded ? 'expanded' : ''],
						on: { click: this.toggleText },
						domProps: { innerHTML: this.observationText }
					})}
				</VCardText>
			</VCard>
		)
	}
}) as unknown as VueConstructor

export default NotificationProposalObservation
